import { createFileRoute } from '@tanstack/react-router';
import { JourneysDashboardHandoff } from '@/pages/workspaces/dashboard/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-route-helpers';

/**
 * The legacy `/journeys/dashboard` URL. It forwards to the canonical Hydra dashboard URL.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the `journeys` segment,
 * so the resolver can rebuild the target when the `/workspaces/last` sentinel needs resolving.
 */
function JourneysDashboardRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysDashboardHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/dashboard')({
  component: JourneysDashboardRoute,
});
